/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshipfileapprovalStudents200,
  GetApiV1ScholarshipfileapprovalStudents400,
  GetApiV1ScholarshipfileapprovalStudents401,
  GetApiV1ScholarshipfileapprovalStudents500,
  GetApiV1ScholarshipfileapprovalStudentsQueryParams,
  GetApiV1ScholarshipfileapprovalStudentsQueryResponse,
} from "../../types/scholarshipTypeFileApprovalController/GetApiV1ScholarshipfileapprovalStudents.ts";
import { scholarshipFileApprovalStudentListViewModelSchema } from "../scholarshipFileApprovalStudentListViewModelSchema.ts";

export const getApiV1ScholarshipfileapprovalStudentsQueryParamsSchema =
  z.object({
    ClassStudentIds: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "IDs das turmas a filtrar. No legado chegava como CSV. Opcional.",
        ),
    ),
    PersonId: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "ID do aluno. Quando informado, os demais filtros e o status geral da documentação são ignorados. Opcional.",
        ),
    ),
    ScholarshipTypeIds: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "IDs dos tipos de bolsa a filtrar. No legado chegava como CSV. Opcional.",
        ),
    ),
    Email: z.optional(
      z
        .string()
        .describe(
          "E-mail exato do aluno. A comparação ignora maiúsculas e minúsculas. Opcional.",
        ),
    ),
    Cpf: z.optional(
      z
        .string()
        .describe(
          "CPF do aluno. Pontos e hífens são desconsiderados na comparação. Opcional.",
        ),
    ),
    EnrollmentStatusId: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "Status de matrícula a filtrar. Opcional. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
        ),
    ),
    HasAnyFilter: z.optional(
      z
        .boolean()
        .describe(
          "Somente leitura. Indica se ao menos um dos seis filtros foi informado — é obrigatório informar pelo menos um.",
        ),
    ),
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ScholarshipfileapprovalStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshipfileapprovalStudents200Schema = z.lazy(
  () => scholarshipFileApprovalStudentListViewModelSchema,
) as unknown as ToZod<GetApiV1ScholarshipfileapprovalStudents200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ScholarshipfileapprovalStudents400Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalStudents400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshipfileapprovalStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalStudents401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshipfileapprovalStudents500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalStudents500>;

export const getApiV1ScholarshipfileapprovalStudentsQueryResponseSchema =
  z.lazy(
    () => getApiV1ScholarshipfileapprovalStudents200Schema,
  ) as unknown as ToZod<GetApiV1ScholarshipfileapprovalStudentsQueryResponse>;
